/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class DataIcon extends BaseIcon {
  getChildren = () => [ <path d="M13,12a3,3,0,1,1,3-3A3,3,0,0,1,13,12Zm-2.63,0H0L5.72,2,9.21,7.56A4,4,0,0,0,10.32,12Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
